import { DateRangeFilter } from '@src/main/modules/messages/utils/templates';
import { TFunction } from 'i18next';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { useCallback } from 'react';

type UsePunctualityDateFilterProps = {
  t: TFunction;
  setInvalidDateModalVisible: (visible: boolean) => void;
};

export const usePunctualityDateFilter = ({
  t,
  setInvalidDateModalVisible,
}: UsePunctualityDateFilterProps) =>
  useCallback(
    (options: ColumnFilterElementTemplateOptions) => (
      <DateRangeFilter
        value={options.value as (Date | null)[] | null}
        onChange={(val) => {
          if (val && val[0] && val[1] && val[0] > val[1]) {
            setInvalidDateModalVisible(true);
            options.filterCallback(null, options.index);
            return;
          }

          options.filterCallback(val, options.index);
        }}
        t={t}
      />
    ),
    [t, setInvalidDateModalVisible],
  );
